export const ContainerStatusInput = [
    {id:1, status:'NOT READY'},
    {id:2, status:'READY TO BOOK'},
    {id:3, status:'BOOKED'},
    {id:4, status:'DISPATCHED TO PLANT'},
    {id:5, status:'LOADING'},
    {id:6, status:'LOADED AND SEALED'},
    {id:7, status:'SHIPPED'}
]
